module.exports = __webpack_public_path__ + "img/chinesecompany151.1313faec.png";